import axios from 'axios'
import rs from '@/services/routerStore';

export default {
  async login(obj){
    try {
      rs.showLoader(true);
      let response =  await axios.post('cuenta/login', obj);
      rs.setUser(response.data);
      localStorage.setItem('sicope-user',JSON.stringify(response.data));
      localStorage.setItem('sicope-busqueda','');
      rs.$router.push('/')
      rs.alert({color:'positive', message:'Bienvenido(a) ' + rs.$store.state.user.Nombre})
      } catch (error) {
         if(error.response.status == 401){
          rs.alert({color:'negative', message:'Lo sentimos, la contraseña es incorrecta o la cuenta de usuario "'+obj.UserName+'" no está registrada en el sistema. Vuelva a intentarlo.'})
         }
      }
      finally{
        rs.showLoader(false)
      }
  },

  async loginVisor(obj){
    try {
      rs.showLoader(true);
      let response =  await axios.post('visor/login', obj);
      rs.setUser(response.data);
      localStorage.setItem('sicope-user',JSON.stringify(response.data));
      localStorage.setItem('sicope-busqueda','');
      rs.$router.push('/visor/incidencias')
      //rs.alert({color:'positive', message:'Bienvenido(a) ' + rs.$store.state.user.Nombre})
      } catch (error) {
         if(error.response.status == 401){
          rs.alert({color:'negative', message:'Lo sentimos, el RFC o NIP son incorrectos, o el servidor público no está registrado en el sistema. Vuelva a intentarlo.'})
         }
      }
      finally{
        rs.showLoader(false)
      }
  },

  async get(url){
    rs.loadUser()
    rs.showLoader(true)
    try {
      const db = await axios.get(url, {
        headers:{
          "Token":rs.$store.state.user.Token
        }
      });
      return db.data
    } catch (error) {
      rs.alert({color:'negative', message:error.message})
      if(error.response.status == 401 || error.toJSON().status===null){
        rs.logOut();
      }
    }
    finally{
      rs.showLoader(false)
    }

  },
  async getVisor(url){
    rs.loadUser()
    rs.showLoader(true)
    try {
      const db = await axios.get(url);
      return db.data
    } catch (error) {
      rs.alert({color:'negative', message:error.message})
      if(error.response.status == 401 || error.toJSON().status===null){
        rs.logOut();
      }
    }
    finally{
      rs.showLoader(false)
    }

  },
  async post(url,obj){
    rs.loadUser()
    rs.showLoader(true)
    try {
      const response = await axios.post(url,obj, {
        headers:{
          "Token":rs.$store.state.user.Token,
        }
      });
      if (response.data.Error) {
        rs.alert({color:'negative', message: response.data.ErrorList.join('<br>')})
      }
      return response.data
    } catch (error) {
      rs.alert({color:'negative', message:error.message})
       if(error.toJSON().status===null){
         rs.logOut();
       }
	   if (error.response.status === 401) {
		   rs.logOut();
	   }
    } finally{
      rs.showLoader(false)
    }

  },

  async postFile(url,obj){
    rs.loadUser()
    rs.showLoader(true)
    try {
      const response = await axios.post(url,obj, {
        headers:{
          "Token":rs.$store.state.user.Token,
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.Error) {
        rs.alert({color:'negative', message: response.data.ErrorList.join('<br>')})
      }
      return response.data
    } catch (error) {
      rs.alert({color:'negative', message:error.message})
       if(error.response.status == 401 || error.toJSON().status===null){
         rs.logOut();
       }
    } finally{
      rs.showLoader(false)
    }

  },

  async delete(url){
    rs.loadUser()
    rs.showLoader(true)
    try {
      const response = await axios.delete(url, {
        headers:{
          "Token":rs.$store.state.user.Token
        }
      });
    } catch (error) {
      rs.alert({color:'negative', message:error.message})
       if(error.response.status == 401 || error.toJSON().status===null){
         rs.logOut();
       }
    } finally{
      rs.showLoader(false)
    }
  }
}

